import { render } from "./MyCouponList.vue?vue&type=template&id=638811c4&scoped=true"
import script from "./MyCouponList.vue?vue&type=script&lang=js"
export * from "./MyCouponList.vue?vue&type=script&lang=js"

import "./MyCouponList.vue?vue&type=style&index=0&id=638811c4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638811c4"]])

export default __exports__